import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  markersList: {
    maxHeight: '155px',
    '& .MuiTableCell-body, & .MuiTableCell-head': {
      border: 'none',
    },
    '& .MuiTableCell-root': {
      padding: 8,
    },
    '& .MuiTableCell-head': {
      color: theme.palette.text.disabled,
    },
  },
  selectedMarker: {
    backgroundColor: 'rgba(62, 62, 62, 0.4)',
  },
  iconAndList: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  tableHead: {
    position: 'relative',
    left: 50,
  },
  markerItems: {
    position: 'relative',
  },
  tableRow: {
    display: 'flex',
  },
  timeIn: {
    position: 'relative',
    paddingRight: '33px',
    borderBottom: 'none',
  },
  timeOut: {
    position: 'relative',
    borderBottom: 'none',
  },
  timeName: {
    position: 'relative',
    paddingRight: '82px',
    borderBottom: 'none',
  },
  timeNotes: {
    position: 'relative',
    borderBottom: 'none',
  },
  markerIn: {
    position: 'relative',
    borderBottom: 'none',
    maxWidth: 95,
  },
  markerOut: {
    minWidth: 95,
    position: 'relative',
    borderBottom: 'none',
  },
  markerName: {
    maxWidth: 135,
    minWidth: 135,
    width: '100%',
    position: 'relative',
    wordWrap: 'break-word',
    borderBottom: 'none',
  },
  markerNotes: {
    maxWidth: 815,
    width: '100%',
    position: 'relative',
    wordWrap: 'break-word',
    borderBottom: 'none',
  },
  iconButton: {
    position: 'relative',
  },
  deleteIcon: {
    position: 'relative',
  },
  editIcon: {
    position: 'relative',
  },
  divider: {
    height: '2px',
  },
}));

export default useStyles;
